import { render, staticRenderFns } from "./underwriting-refer.vue?vue&type=template&id=c7c3c050&"
import script from "./underwriting-refer.vue?vue&type=script&lang=js&"
export * from "./underwriting-refer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports